import React, { ChangeEventHandler } from "react";
import { GridLegacy, TextField } from "@mui/material";

type GridRowDescriptionWithTextField = {
  description: string;
  value: string;
  onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
};

function GridRowDescriptionWithTextField(props: GridRowDescriptionWithTextField) {
  return (
    <>
      <GridLegacy item xs={6}>
        {props.description}
      </GridLegacy>
      <GridLegacy container item justify={"flex-end"} xs={6}>
        <TextField onChange={props.onChange} value={props.value} />
      </GridLegacy>
    </>
  );
}

export default GridRowDescriptionWithTextField;
